import { Modal } from "react-bootstrap";
import classes from "./RadarModal.module.css";
import RadarChart from "./RadarChart";

type RadarModalProps = {
  showRadar: boolean;
  handleCloseRadar: () => void;
};

const RadarModal: React.FC<RadarModalProps> = ({ showRadar, handleCloseRadar }) => {
  return (
    <Modal
      show={showRadar}
      onHide={handleCloseRadar}
      dialogClassName={classes.container}
      contentClassName={classes.content}
      backdropClassName={classes.backdrop}
    >
      <Modal.Body className={classes.body}>
        <div className={classes['chart-container']}>
          <RadarChart isOpened={true} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RadarModal;
